// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"89":"0fdd1b19","96":"8550e732","130":"24cbc160","364":"7c675751","454":"828e071a","474":"68286fb8","493":"c4442706","922":"2a16fdde"}[chunkId] + ".css";
};